import { ComponentHelper } from "../core/util/componentHelper";
import { TextBox } from "../core/components/textBox";
import { Helper } from "../core/util/helper";
import {Button} from "../core/components/button";
import {Config} from "../core/config/config";
import {DialogHelper} from "../core/util/dialogHelper";
import { BaseComponentProps, BaseField } from "../core/components/baseComponentProps";
import React from "react"
export default class ApiKeyBox extends React.Component<ApiKeyBoxProps, ApiKeyBoxState>{
    private factory = ComponentHelper.createFactory();
    private labelText: string;
    private labelTextWaring: boolean;
   
    
    constructor(props: ApiKeyBoxProps) { 
        super(props)
        this.labelText = Helper.hasValue((this.props.field as any).labelText) ? (this.props.field as any).labelText : null;
        this.labelTextWaring = Helper.hasValue((this.props.field as any).labelTextWarning) ? (this.props.field as any).labelTextWarning : false;
        this.state = {
            value: props.value
        }
    }

    private setValue = (value: string) => {
        this.setState({ value: value }, () => {
            this.props.onChange(this.props.field, value)
        })
    }

    private handleBtnClick = async (e) => {
        let key = await DialogHelper.prompt(Config.translations.reEnterApiKey, "", 250, false, true);
        if (!Helper.isNullOrEmpty(key) && key.length > 3)
            this.setValue(key);
    }

    private handleDeleteClick = async (e) => {
        const isOk = await DialogHelper.confirm(Config.translations.deleteApiKey + "?");
        if (isOk)
            this.setValue("");
    }
    
    private createTextBox = () => {
        const props = this.factory.getDefaultTextBoxProps();
        props.value = this.state.value;
        props.onChange = (_, value: string) => {
            this.setValue(value);
        }
        props.field.triggerOnChange = true;
        props.disabled = true; 
        return (
            <div style={{ marginRight: "7px", flex: 1 }}>
                <TextBox   {...props} />
            </div>
        );
    }
    
    render() {
        let label = null;
        if (this.labelText != null) {
            label = this.labelTextWaring ?
                (<div style={{
                    marginTop: "5px",
                    "backgroundColor": "#fff19d",
                    "color": "#6a5b00"
                }}>{this.labelText}</div>) :
                (<div style={{marginTop: "5px",}}>{this.labelText}</div>);
        }
        
        const disabled = this.props.disabled === true;
        
        return (
            <>
                <div style={{ display: "flex", alignItems: "center", width: "100%", flexWrap: "wrap" }}>
                    {this.createTextBox()}
                    <Button readOnly={disabled || !Helper.hasValue(this.state.value)}
                            iconName="trash"
                            handleClick={this.handleDeleteClick}
                            title={Config.translations.deleteApiKey} >
                    </Button>
                    <Button readOnly={disabled} 
                            iconName="pen" 
                            handleClick={this.handleBtnClick}
                            title={Config.translations.reEnterApiKey} >
                    </Button>
                </div>
                {label}
            </>);
    }
}

interface ApiKeyBoxProps extends BaseComponentProps{
    labelText?: string
    labelTextWarning?: boolean;
}

interface ApiKeyBoxField extends BaseField {
}

interface ApiKeyBoxState { 
    value: string;
    disabled?: boolean;
}